export default __webpack_public_path__ + "static/iPad-Mockup2-08416cef822947c74b4c16da4e9d1409.png";